import { from, Subject } from 'rxjs';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, ViewChild, TemplateRef} from '@angular/core';
import { APIService } from '../../api.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-expense-config',
  templateUrl: './expense-config.component.html',
  styleUrls: ['./expense-config.component.scss']
})
export class ExpenseConfigComponent implements OnInit{
  @Input() mdlRef: any;
  @ViewChild('Addexpense') addexpenseTemplate!: TemplateRef<any>;
  expensemodalshow:boolean = false
  costTypeList: any = [];
  agencyData: any = [];
  jarvisData: any = []; 
  userData: any = []; 
  rights: any = [];
  UIDs : any = [];
  isEdit: boolean = false;
  isDelete:boolean = false;
  expense: string = "";
  newExpense = {
      expenseName: ''
  }
  expenseData : any = [];
  constructor(private modalService: NgbModal, private apiService: APIService, private router: Router, private commonService: CommonService, private loadingPnl: NgxSpinnerService) { }

  ngOnInit(): void {
    if(this.mdlRef){
    this.expensemodalshow = true;
    }
  
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    var user = this.apiService.getCookie("J");
    if (user) {
      this.userData = JSON.parse(user);
    }

    this.getExpense();

    let expenseParam = this.commonService.GetParam("o");
    if (expenseParam && expenseParam === "1") {
      setTimeout(() => {
        if (this.addexpenseTemplate) {
          this.open(this.addexpenseTemplate, 0);
        }
      }, 500);
    }
  }   

  getExpense(){
    var erpCfgData = this.apiService.getCookie("ERP_Cfg");
    debugger
    if (erpCfgData) {
    let tempCfg = JSON.parse(erpCfgData);
    if(tempCfg.length > 0){
      if(tempCfg[0].CostTypes){
        let tempcostTypeList = JSON.parse(tempCfg[0].CostTypes);
        if(tempcostTypeList.length > 0)
        {
          this.costTypeList = tempcostTypeList.filter((x: any) => x.IsD == false)
          this.costTypeList = this.costTypeList.sort((a: any, b: any) => a.CNm.localeCompare(b.CNm));
        }
      }
    }
   
  }}
  closeResult: any;
  modalReference: any;
  open(content: any, id: number) {
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class' });
    this.modalReference.result.then((result: any) => {
        this.closeResult = `Closed with: ${result}`;
    },
        (reason: any) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });

    if (id == 0) {
      this.newExpense.expenseName = ""
    }
    else{
      var expenseData = this.costTypeList.filter(function (element: any, index: any) {
          return (element.CID == id);
      });
      const stageOld:string = expenseData[0].CNm;
      this.expense = stageOld;
    }
}

 //addExpense() - add new unit
 addExpense(expense: string){
  debugger
  this.expenseData = []
  if(expense.trim() == ''){
    this.apiService.successAlert('Please enter expense name.');
    return;
  }
  if(this.costTypeList.length > 0){
    let tempCostType = this.costTypeList.filter((x: any) => x.CNm == expense)
    if(tempCostType.length > 0){
      this.apiService.successAlert('This cost type already exists.');
      return;
    }
  }
  
  this.expenseData = [{
    CID: 0,
    CNm: expense,
  }]

  
  this.save()

}

  // deleteExpense() - delete reason
  deleteExpense(e:any){
    this.expenseData = [];
    if(confirm("Are you sure you want to delete this Expense Type?")){
      this.isDelete = true;
      this.expenseData = [{
        CID: e.CID,
        CNm: e.CNm,
      }]
      this.save();
    }
  }
  

//save() - save store
save(){
    var tempData = [{
      'ChangeType': this.isDelete ? 'COSTTYPEDELETE':'COSTTYPESADD',
      'GSTLdgrs':'',
      'Units': '',
      'Stores':'',
      'ItemCategories': '',
      'PrdJobStages':'',
      'ValnMethod':1,
      'PrdRejnReasons': '',
      'HSNSAC' : '',      
      'costTypes': this.expenseData ? JSON.stringify(this.expenseData): []
    }]
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];
    this.loadingPnl.show();
    this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
    }

    //successVchrEntry - success voucher entry handler
   successEntry(res: any) {
    debugger
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
        if (ErpData.Table2) {
          let ErpCfgData = JSON.stringify(ErpData.Table2);
          this.apiService.setCookie("ERP_Cfg", ErpCfgData);
          this.getExpense();  
          this.newExpense.expenseName = "";
        }
    }
    //this.closeModel();
    this.closeModal();
    // this.modalReference.close();
    }
}

//failureResp - failure handler
failureResp(res: any) {
  if (res.error) {
  }
}
closeModal() {
  this.modalReference.close();
}


private getDismissReason(reason: any): string {
  //this.getRigths();
    if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
    } else {
        return `with: ${reason}`;
    }
}

// public closeModal($event: any) {
//     this.modalReference.close();
//     if ($event) {
//       //  this.changingValue.next($event);
//     }
// }

  backBtn() {
    window.history.back();
  }

  closeModel() {
    let doneObj = {
      action: 'Done',
      obj: null
    }
    this.mdlRef.close(doneObj);
  }
 
  // change color
changeColor(ind: any){
  var clr = ""
  switch(ind) { 

    case 0: { 
      clr = 'orangeBadge'
       break; 
    } 
    case 1: {
      clr = 'yellowBadge'
      break; 
    } 
    case 2: { 
      clr = 'greenBadge'
       break; 
    } 
    case 3: { 
      clr = 'tealBadge'
       break; 
    } 
    case 4: { 
      clr = 'blueBadge'
       break; 
    } 
    case 5: { 
      clr = 'darkBlueBadge'
       break; 
    } 
    case 6: { 
      clr = 'brownBadge'
       break; 
    } 
  
 }
 return clr; 
}


 //editExpense() - edit store
//  editExpense(name: any , obj: any){
//   let oldName = this.expense
//   let ind = this.editExpenseId
//   var expenseData = this.Expenses.filter(function (element: any, index: any) {
//     return (element.CID == ind);
// });
 
//   let tempStore ={
//     'CID': expenseData[0].CID,
//     'CNm': name,  
//   }
//   let flag = false
//   if(name == ''){
//     flag = true
//     this.expense = oldName;
//     alert("Please enter expense name.")
//     return
//   }
//   for (let i = 0; i < this.Expenses.length; i++) {
//     if(name == this.Expenses[i].CNm){
//       flag = true
//       break
//     }
//   }
//   // if(oldName.toUpperCase() == expenseData[0].SNm.toUpperCase()){
//   //   flag = false
//   // }
  

//   if(!flag){
//     for(let i = 0; i < this.Expenses.length; i++){
//       if(this.Expenses[i].CID == expenseData[0].CID){
//         this.Expenses[i].CNm = tempStore.CNm;
//       }
//     }
//     this.save();
//     this.modalReference.close();
//   }
//   else{
//     this.expense = expenseData[0].CNm
//     alert("Please enter valid expense name.")
//   }

// }

}
